import React from 'react';
import { Link } from 'react-router-dom';

const LinksPage = () => {
  const categories = [
    {
      title: 'Formazione & Percorsi',
      color: '#00FF41',
      links: [
        { label: 'FORMAZIONE DIGITALE', url: '/formazione', desc: '1ª Elementare → Master', highlight: true },
        { label: 'Questionario VAK', url: '/formazione#vak', desc: 'Scopri come impari meglio' },
        { label: 'Le 10 Lezioni', url: '/formazione', desc: 'Da Wikipedia al primo prompt AI' },
        { label: 'Certificazioni', url: '/formazione', desc: 'Regione, CPIA, ICDL, Google, UniSi' },
      ]
    },
    {
      title: 'Doposcuola & Servizi',
      color: '#4ECDC4',
      links: [
        { label: 'DOPOSCUOLA SPORT', url: '/sede', desc: 'Tutti i pomeriggi 14-18' },
        { label: 'Stage R€TRIBUITI', url: '/sede', desc: 'PNSD + Toscana Lavoro' },
        { label: 'La Sede & Orari', url: '/sede', desc: 'Sharing degli spazi' },
        { label: 'Per il Cittadino', url: '/cittadino', desc: 'SPID, Google, digitale base' },
      ]
    },
    {
      title: 'Sostieni & Dona',
      color: '#FFD700',
      links: [
        { label: 'ISCRIVITI — 19€', url: '/dona', desc: 'Tessera + T-shirt + Portachiavi', highlight: true },
        { label: 'Dona — Sistema Cinture', url: '/dona', desc: 'Da 1€ a 999€, premi esclusivi' },
        { label: 'Sponsor Aziendale — 999€', url: '/dona', desc: 'Deducibile 100%' },
      ]
    },
    {
      title: 'Istituzionale & Pitch',
      color: '#FF6B6B',
      links: [
        { label: 'PITCH TEDx', url: '/pitch', desc: 'Presentazione completa progetto' },
        { label: 'Email per Enti', url: '/email', desc: 'Template pronti per Comune, ANCI' },
        { label: 'Email Team', url: '/email', desc: 'Zammariello (Social) + Ciani (Brand)' },
        { label: 'Brand Kit & Risorse', url: '/brand', desc: 'Logo, colori, tipografia' },
      ]
    },
    {
      title: 'Community & Social',
      color: '#FF00FF',
      links: [
        { label: 'PODCAST AI_COVO', url: '/podcast', desc: 'La storia, i visionari, la missione', highlight: true },
        { label: 'WhatsApp', url: 'https://wa.me/393273839782', external: true, desc: 'Scrivici direttamente' },
        { label: 'All About Us', url: '/about', desc: 'Chi siamo, la mission' },
        { label: 'Contattaci', url: '/contatti', desc: 'Form di contatto' },
        { label: 'Hub Sociale', url: '/hub', desc: 'Il progetto in dettaglio' },
      ]
    },
    {
      title: 'Risorse & Download',
      color: '#00BFFF',
      links: [
        { label: 'VIDEO PROMO', url: '/linksvideo', desc: 'Video in lavorazione' },
        { label: 'Scarica Logo PNG', url: '/logo_final.png', external: true, desc: 'Logo ufficiale' },
        { label: 'Recap Progetto', url: '/recap', desc: 'Panoramica completa' },
      ]
    },
  ];

  return (
    <main data-testid="links-page" className="min-h-screen pt-24 pb-16">
      <div className="max-w-2xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-10">
          <img src="/logo_final.png" alt="AI_COVO" className="h-20 mx-auto mb-4" />
          <h1 className="text-2xl font-black text-[#00FF41] mb-1">&lt;/AI_COVO.tech&gt;<sup style={{ fontSize: '0.45em', verticalAlign: 'super', marginLeft: '1px', fontWeight: 400, fontFamily: 'Georgia, serif' }}>&reg;</sup></h1>
          <p className="text-sm font-bold shimmer-text mb-1">ROADMAP</p>
          <p className="text-zinc-500 text-xs">Colle Val d'Elsa · Digital Hub Sociale</p>
        </div>

        {/* T-SHIRT CTA — Featured */}
        <Link
          to="/tshirt"
          data-testid="link-tshirt-cta"
          className="block w-full mb-6 bg-[#0A0A0A] border-2 border-[#00FF41] rounded-xl overflow-hidden hover:border-[#33FF66] transition-all group relative"
        >
          <div className="absolute top-3 left-3 z-10 bg-[#FF6B35] text-white font-black text-[10px] px-3 py-1 rounded-full tracking-wider uppercase">
            Il più richiesto
          </div>
          <div className="absolute top-3 right-3 z-10 bg-red-600/90 text-white font-mono text-[10px] px-3 py-1 rounded-full animate-pulse">
            Ne rimangono 5...
          </div>
          <div className="flex items-center gap-4 p-4">
            <div className="w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden bg-black">
              <img src="/tshirt_ragazzo.png" alt="T-Shirt </GEN..." className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" />
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-white font-black text-lg group-hover:text-[#00FF41] transition-colors">T-Shirt &lt;/GEN...</h3>
              <p className="text-zinc-400 text-xs mt-1">Total Black · Logo &lt;/ sul cuore · Stile All Blacks</p>
              <p className="text-[#00FF41] font-mono text-xs mt-2 font-bold">Cintura Blu — 15€ donazione</p>
            </div>
            <svg className="w-6 h-6 text-[#00FF41] flex-shrink-0 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5"><path d="M9 18l6-6-6-6"/></svg>
          </div>
        </Link>

        {/* Main CTA */}
        <Link 
          to="/dona"
          data-testid="link-iscriviti"
          className="block w-full bg-[#00FF41] text-black font-bold text-center py-4 px-6 mb-8 hover:bg-[#33FF66] transition-colors"
        >
          ISCRIVITI ORA — 19€
          <span className="block text-sm font-normal mt-1">Tessera + T-shirt + Portachiavi</span>
        </Link>

        {/* QR Code per Adesivi / Street Art */}
        <div className="mb-8 bg-[#0A0A0A] border border-[#00FF41]/30 p-6 text-center" data-testid="qr-section">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-4">QR Code — Adesivi & Street Art</p>
          <div className="flex flex-col sm:flex-row justify-center items-center gap-6">
            <div>
              <img src="/qr_roadmap.png" alt="QR Roadmap AI_COVO" className="w-40 h-40 mx-auto border border-[#00FF41]/20" />
              <p className="text-zinc-500 text-xs mt-2">Verde Matrix (web)</p>
            </div>
            <div>
              <img src="/qr_roadmap_stencil.png" alt="QR Stencil" className="w-40 h-40 mx-auto border border-zinc-700" />
              <p className="text-zinc-500 text-xs mt-2">Bianco/Nero (stencil)</p>
            </div>
          </div>
          <p className="text-zinc-400 text-xs mt-4">Scarica e stampa su adesivi, stencil, volantini. Punta a <span className="text-[#00FF41]">aicovo.tech/links</span></p>
          <div className="flex justify-center gap-3 mt-3">
            <a href="/qr_roadmap.png" download className="font-mono text-[10px] text-[#00FF41] border border-[#00FF41]/30 px-3 py-1 hover:bg-[#00FF41]/10 transition-colors">SCARICA VERDE</a>
            <a href="/qr_roadmap_stencil.png" download className="font-mono text-[10px] text-white border border-zinc-600 px-3 py-1 hover:bg-zinc-800 transition-colors">SCARICA STENCIL</a>
          </div>
        </div>

        {/* Ufficio Stampa & Tipografia */}
        <div className="mb-8" data-testid="print-section">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-2 h-2 rounded-full bg-white" />
            <p className="font-mono text-xs uppercase tracking-wider text-white">Ufficio Stampa & Tipografia</p>
          </div>
          <div className="space-y-2">
            <a href="/logo_final.png" download className="block w-full bg-[#0A0A0A] border border-zinc-800 hover:border-zinc-600 text-left py-3 px-5 transition-all hover:-translate-y-0.5">
              <p className="font-bold text-sm text-white">Logo PNG (trasparente)</p>
              <p className="text-zinc-500 text-xs mt-0.5">Per stampa su qualsiasi sfondo</p>
            </a>
            <a href="/qr_roadmap.png" download className="block w-full bg-[#0A0A0A] border border-zinc-800 hover:border-zinc-600 text-left py-3 px-5 transition-all hover:-translate-y-0.5">
              <p className="font-bold text-sm text-white">QR Code Verde Matrix (PNG)</p>
              <p className="text-zinc-500 text-xs mt-0.5">Per adesivi, volantini, biglietti da visita</p>
            </a>
            <a href="/qr_roadmap_stencil.png" download className="block w-full bg-[#0A0A0A] border border-zinc-800 hover:border-zinc-600 text-left py-3 px-5 transition-all hover:-translate-y-0.5">
              <p className="font-bold text-sm text-white">QR Code Stencil B/N (PNG)</p>
              <p className="text-zinc-500 text-xs mt-0.5">Per stencil street art, stampa monocromatica</p>
            </a>
            <Link to="/brand" className="block w-full bg-[#0A0A0A] border border-zinc-800 hover:border-zinc-600 text-left py-3 px-5 transition-all hover:-translate-y-0.5">
              <p className="font-bold text-sm text-white">Brand Kit Completo</p>
              <p className="text-zinc-500 text-xs mt-0.5">Colori (#000, #00FF41), font (Monospace), linee guida</p>
            </Link>
            <div className="block w-full bg-[#0A0A0A] border border-zinc-800 text-left py-3 px-5">
              <p className="font-bold text-sm text-white">Specifiche Tipografiche</p>
              <div className="grid grid-cols-2 gap-2 mt-2">
                <div className="text-zinc-500 text-xs"><span className="text-zinc-300">Colore primario:</span> #00FF41</div>
                <div className="text-zinc-500 text-xs"><span className="text-zinc-300">Background:</span> #000000</div>
                <div className="text-zinc-500 text-xs"><span className="text-zinc-300">Font:</span> Monospace / JetBrains</div>
                <div className="text-zinc-500 text-xs"><span className="text-zinc-300">Nicklogo:</span> &lt; /</div>
                <div className="text-zinc-500 text-xs"><span className="text-zinc-300">Brand:</span> &lt;/AI_covo.tech&gt;®</div>
                <div className="text-zinc-500 text-xs"><span className="text-zinc-300">Pantone:</span> Green C (simile)</div>
              </div>
            </div>
            
            <Link to="/email" className="block w-full bg-[#0A0A0A] border border-zinc-800 hover:border-zinc-600 text-left py-3 px-5 transition-all hover:-translate-y-0.5">
              <p className="font-bold text-sm text-white">Email Template Pronti</p>
              <p className="text-zinc-500 text-xs mt-0.5">Comune, ANCI, Sponsor, Team (copia e invia)</p>
            </Link>
            <Link to="/pitch" className="block w-full bg-[#0A0A0A] border border-zinc-800 hover:border-zinc-600 text-left py-3 px-5 transition-all hover:-translate-y-0.5">
              <p className="font-bold text-sm text-white">Pitch Deck / Presentazione PDF</p>
              <p className="text-zinc-500 text-xs mt-0.5">Per stampa cartacea o proiezione</p>
            </Link>
          </div>
        </div>

        {/* Categories */}
        {categories.map((cat, ci) => (
          <div key={ci} className="mb-6" data-testid={`links-category-${ci}`}>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-2 h-2 rounded-full" style={{ background: cat.color }} />
              <p className="font-mono text-xs uppercase tracking-wider" style={{ color: cat.color }}>{cat.title}</p>
            </div>
            <div className="space-y-2">
              {cat.links.map((link, li) => {
                const cls = `block w-full border text-left py-3 px-5 transition-all hover:-translate-y-0.5 ${
                  link.highlight 
                    ? 'bg-[#00FF41]/5 border-[#00FF41]/40 hover:border-[#00FF41]' 
                    : 'bg-[#0A0A0A] border-zinc-800 hover:border-zinc-600'
                }`;
                const inner = (
                  <>
                    <p className={`font-bold text-sm ${link.highlight ? 'text-[#00FF41]' : 'text-white'}`}>{link.label}</p>
                    {link.desc && <p className="text-zinc-500 text-xs mt-0.5">{link.desc}</p>}
                  </>
                );
                return link.external ? (
                  <a key={li} href={link.url} target="_blank" rel="noopener noreferrer" className={cls} data-testid={`link-${ci}-${li}`}>{inner}</a>
                ) : (
                  <Link key={li} to={link.url} className={cls} data-testid={`link-${ci}-${li}`}>{inner}</Link>
                );
              })}
            </div>
          </div>
        ))}

        {/* Stats */}
        <div className="grid grid-cols-3 gap-4 mt-8 mb-8">
          <div className="text-center">
            <p className="text-xl font-bold text-[#00FF41]">1000</p>
            <p className="text-[10px] text-zinc-500">Obiettivo Soci</p>
          </div>
          <div className="text-center">
            <p className="text-xl font-bold text-[#00FF41]">5</p>
            <p className="text-[10px] text-zinc-500">Livelli Formazione</p>
          </div>
          <div className="text-center">
            <p className="text-xl font-bold text-[#00FF41]">6</p>
            <p className="text-[10px] text-zinc-500">Certificazioni</p>
          </div>
        </div>

        {/* Quote */}
        <div className="border-l-4 border-[#00FF41] pl-4 mb-8">
          <p className="text-zinc-400 italic text-sm">
            "Non hanno più qualcuno che crede in loro.<br />
            <span className="text-[#00FF41] font-bold">Lo faremo noi.</span>"
          </p>
        </div>

        {/* Footer */}
        <div className="text-center text-zinc-600 text-xs">
          <p>© 2030 AI_COVO</p>
          <p className="shimmer-text text-sm mt-1">DIGITAL HUB SOCIALE</p>
          <p className="mt-1">Colle Val d'Elsa · Toscana · Italia</p>
        </div>
      </div>
    </main>
  );
};

export default LinksPage;
